import { Component, Inject, InjectionToken, Injector, Optional, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { BusinessUnitModel } from '@fi-app/business-unit/business-unit.model';
import { IFiUniqueContactData } from '@fi-shared/fi-directives/fi-custom-validators/fi-unique-contact-async-validator.directive';
import { IContactModel } from '@fi-shared/models/common';
import { FiUserSignInSettings } from '@fi-app/user/user-edit/fi-user-sign-in-settings';
import { FiContactsService } from '@fi-shared/fi-contacts/fi-contacts.service';
import { IFiContactData } from '@fi-shared/fi-contacts/fi-contacts';

export type TFiUserEditDataFieldEmailAddress_Settings = {
    isNewAddButtonLayout?: boolean;
    dataForUniqueEmailCheckFn?: (emailAddress: IContactModel) => IFiUniqueContactData;
    fiUserSignInSettings: FiUserSignInSettings;
    contactData?: IFiContactData;
};

export const FiUserEditDataFieldEmailAddress_Settings = new InjectionToken<TFiUserEditDataFieldEmailAddress_Settings>(
    'FiUserEditDataFieldName_Settings',
);

@Component({
    selector: 'data-field-edit-email-address',
    template: `
        <fi-email-address-contacts
            [(ngModel)]="dataFieldObject.EmailAddressContacts"
            [isRequired]="isRequired()"
            [fiUserSignInSettings]="getFiUserSignInSettings()"
            [dataForUniqueEmailCheck]="getDataForUniqueEmailCheck()"
            [isNewAddButtonLayout]="isNewAddButtonLayout()"
            [contactData]="getContactData()"
            [isSystemObject]="dataFieldObject.IsSystemObject"
            (onContactChange)="onEmailAddressChanged($event)"
        >
        </fi-email-address-contacts>
    `,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-edit-email-address' },
    standalone: false,
})
export class DataFieldEditEmailAddressComponent extends DataFieldEditBase {
    private fiContactsService: FiContactsService;

    constructor(
        injector: Injector,
        @Optional()
        @Inject(FiUserEditDataFieldEmailAddress_Settings)
        private settings: TFiUserEditDataFieldEmailAddress_Settings,
    ) {
        super(injector);
        this.fiContactsService = this.injector.get(FiContactsService);
    }

    isRequired(): boolean {
        if (this.dataFieldObject instanceof BusinessUnitModel) {
            return this.dataField.IsSetRequired;
        }
        return false;
    }

    getContactData(): IFiContactData {
        return (
            this.settings?.contactData ??
            this.fiContactsService.getContactData(() => this.dataFieldObject.EmailAddressContacts)
        );
    }

    isNewAddButtonLayout(): boolean {
        return this.settings?.isNewAddButtonLayout;
    }

    getDataForUniqueEmailCheck(): (contact: IContactModel) => IFiUniqueContactData {
        return this.settings?.dataForUniqueEmailCheckFn ? this.settings.dataForUniqueEmailCheckFn : undefined;
    }

    getFiUserSignInSettings(): FiUserSignInSettings {
        return this.settings?.fiUserSignInSettings;
    }

    onEmailAddressChanged($event: IContactModel) {
        if (this.settings) {
            this.settings.contactData?.onContactValueChanged($event);
        }
    }
}
